import App from './App';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import appConfig from 'config/appConfig';
import { FirebaseProvider, store } from 'common';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProviderApp } from 'components/Theme/theme';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const config = {
    appId: appConfig.REACT_APP_FIREBASE_APP_ID,
    apiKey: appConfig.REACT_APP_FIREBASE_API_KEY,
    projectId: appConfig.REACT_APP_FIREBASE_PROJECT_ID,
    authDomain: appConfig.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: appConfig.REACT_APP_FIREBASE_DATABASE_URL,
    storageBucket: appConfig.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // measurementId: appConfig.REACT_APP_FIREBASE_MEASUREMENT_ID,
    messagingSenderId: appConfig.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
}

root.render(
    <HelmetProvider>
        <Provider store={store}>
            <FirebaseProvider config={config as any}>
                <ThemeProviderApp>
                    <App />
                </ThemeProviderApp>
            </FirebaseProvider>
        </Provider>
    </HelmetProvider>
);